export default __webpack_public_path__ + "static/media/app_development_SVG.415792ef.svg";